import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=52f9920e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=52f9920e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9920e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f9920e')) {
      api.createRecord('52f9920e', component.options)
    } else {
      api.reload('52f9920e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=52f9920e&scoped=true&", function () {
      api.rerender('52f9920e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performanceCalculation/views/result_statement/annual_terminal_performance_report/scanDetail/detail.vue"
export default component.exports